export default __webpack_public_path__ + "static/media/dosa.b500d1fb.png";